import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-busqueda-persona',
  templateUrl: './dialog-busqueda-persona.component.html',
  styleUrls: ['./dialog-busqueda-persona.component.css']
})
export class DialogBusquedaPersonaComponent implements OnInit {

  personas=[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogBusquedaPersonaComponent >
  ) {
    this.personas=this.dataDialog;
   }

  ngOnInit() {
  }


  personaSeleccionada(persona){
    //console.log(persona);
    this.dialogRef.close(persona);
  }

}
